export const typeContractor = [
  { name: 'Юридическое лицо', id: 0 },
  { name: 'ИП', id: 1 },
];

export const typeContractorType = [
  { name: 'Юридическое лицо', id: 0 },
  { name: 'ИП', id: 1 },
  { name: 'Физ. лицо', id: 2 },
];

export const male = [
  { name: 'Мужской', id: 0 },
  { name: 'Женский', id: 1 },
];
